import {
  PatchedUserPreferences,
  useApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateMutation,
} from '../../../../../store/generated/portal/user-preferences';
import { userContextApi } from '../../../../../common/api/userContextApi';

export const useUpdateUserPreferences = () => {
  const [updatePreferences, updateResult] =
    useApiPortalV1UserPreferencesUpdatePreferencesPartialUpdateMutation();
  // Use the enhanced API with tags - no manual refetch needed, invalidation handles it
  const { refetch } = userContextApi.useApiPortalV1ContextRetrieveQuery();

  const updateUserPreferences = async (id: number, preferences: PatchedUserPreferences) => {
    try {
      await updatePreferences({
        id,
        patchedUserPreferences: preferences,
      }).unwrap();
      refetch();
    } catch (error) {
      console.error('Error updating user preferences:', error);
      throw error;
    }
  };

  return {
    updateUserPreferences,
    isLoading: updateResult.isLoading,
    isError: updateResult.isError,
    error: updateResult.error,
  };
};
